/**
 /**
 * ReportSubscribersActivitySeed entity class
 */

import moment from 'moment'

/**
 * ReportSubscribersActivitySeedFactory
 * returns ReportSubscribersActivitySeed entity class
 *
 * @class ReportSubscribersActivitySeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribersActivitySeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersActivitySeedFactory
 */
/* @ngInject */
export default function ReportSubscribersActivitySeedFactory (Entity, ReportSeed) {
  /* === ReportSubscribersActivitySeed class === */

  /**
   * ReportSubscribersActivitySeed model
   *
   * @class ReportSubscribersActivitySeed
   * @classdesc ReportSubscribersActivitySeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportSubscribersActivitySeed entity fields
   * @return {models.ReportSubscribersActivitySeed} ReportSubscribersActivitySeed entity
   */
  function ReportSubscribersActivitySeed () {
    var obj = ReportSeed.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribersActivitySeed.prototype = Object.create(ReportSeed.prototype)
  ReportSubscribersActivitySeed.prototype.constructor = ReportSubscribersActivitySeed

  /* === ReportSubscribersActivitySeed instance methods & fields === */

  Object.assign(ReportSubscribersActivitySeed.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportSubscribersActivitySeed#
     * @type {Object}
     */
    _fields: {
      name: String,
      reportType: String,
      networks: [],
      startDate: String,
      endDate: String,
      $fromDateTime: Date,
      $toDateTime: Date
    },

    /**
     * Get underlying object
     *
     * @memberof models.ReportSubscribersActivitySeed#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.startDate = moment(this.$fromDateTime).utc().format('YYYY-MM-DD')
      this.endDate = moment(this.$toDateTime).utc().endOf('day').format('YYYY-MM-DD')
      var ret = Entity.prototype._object.apply(this, arguments)

      return ret
    },

    /**
     * Prepare object
     *
     * @memberof models.StreamsReportSeed#
     * @override
     */
    _prepare: function () {
      this.$fromDateTime = moment().subtract(1, 'day').toDate()
      this.$toDateTime = moment().toDate()
    }
  })

  /* === ReportSubscribersActivitySeed static methods & fields === */

  // copy all static methods from ReportSeed class
  Object.assign(ReportSubscribersActivitySeed, ReportSeed)
  ReportSubscribersActivitySeed._name = 'ReportSubscribersActivitySeed'
  ReportSubscribersActivitySeed.init()

  // permissions
  // ReportSubscribersActivitySeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribersActivitySeed
}
